import type { GencowAuthConfig, GencowDefaultUserIdentity, RlsSessionContext } from "@gencow/core";
import {
  defaultRlsSessionContext,
  hasMapSessionToContext,
  validateRlsSessionContext,
} from "@gencow/core";

/**
 * Maps `AppUser` → `RlsSessionContext` for `createRlsDb`.
 */
export function buildRlsSessionContextFromAuthConfig<TUser extends GencowDefaultUserIdentity>(
  user: TUser | null,
  authConfig?: GencowAuthConfig,
): RlsSessionContext {
  const rls = authConfig?.rls;
  if (!rls) {
    return defaultRlsSessionContext(String(user?.id ?? ""));
  }

  if (hasMapSessionToContext(rls)) {
    const mapped = rls.mapSessionToContext({ user });
    if (mapped instanceof Promise) {
      throw new Error(
        "buildRlsSessionContextFromAuthConfig: async mapSessionToContext is not supported — return RlsSessionContext synchronously",
      );
    }
    validateRlsSessionContext(mapped);
    return mapped;
  }

  return defaultRlsSessionContext(String(user?.id ?? ""));
}

/** Fail-closed session for refresh / unauthenticated request paths. */
export function emptyRlsSessionContextFromAuthConfig(authConfig?: GencowAuthConfig): RlsSessionContext {
  return buildRlsSessionContextFromAuthConfig(null, authConfig);
}
